import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DialogService} from '@shared/services/dialog-service';
import {debounce, takeUntil} from 'rxjs/operators';
import {timer} from 'rxjs';
import {FlowChartDataService} from "@features/data-survey/services/flow-chart-data.service";
import {OptionItem} from '@shared/models/option-item';
import {EliteFormGeneralNodes} from '@features/elite-form/models/elite-form-common-data-models';
import {MatTabChangeEvent} from '@angular/material/tabs';
import _ from 'lodash';
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'lib-elite-form-designer-left-sidebar',
  templateUrl: './elite-form-designer-left-sidebar.component.html',
  styleUrls: ['./elite-form-designer-left-sidebar.component.scss']
})
export class EliteFormDesignerLeftSidebarComponent implements OnInit, OnDestroy {
  @Input() isCollapsed: boolean;
  @Input() tags: string[] = [];
  @Input() toolId = 'Elite-Form';
  @Input() sourceType: string;
  @Input() flowchartId: string;
  @Input() isQnrSet: boolean;
  @Input() enableQnrFieldImport: boolean;

  existingQuestions: any[];

  componentId = 'form-designer-left-sidebar';
  inputForm: FormGroup;

  panelOpenState: boolean;
  isOpen: boolean[] = [];
  viewNodeGroups: any;

  private currentText: string;
  private nodeGroups: FormNodeGroup[] = [];
  private customDataTypes: any;

  tabList: any[];
  private unSubscribe$ = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private dialogService: DialogService,
              private flowChartDataService: FlowChartDataService) { }

  async ngOnInit() {
    this.isOpen[0] = true;
    this.viewNodeGroups = this.nodeGroups;
    this.inputForm = this.formBuilder.group({
      searchText: ['']
    });
    this.flowChartDataService.fetchCustomDataTypes("EliteFormFields").pipe(takeUntil(this.unSubscribe$)).subscribe(
      (value) => {
        this.customDataTypes = value;
        this.setNodes(this.customDataTypes);
      }
    );
    this.inputForm.valueChanges.pipe(debounce(() => timer(500))).subscribe(() => {
      this.currentText = this.inputForm.controls['searchText'].value.toLowerCase();
      const value = this.inputForm.controls['searchText'].value;
      this.onValueChanges(value);
    });

    if (this.enableQnrFieldImport) {
      this.existingQuestions = await this.getFlatQuestions();
      this.setTabList();
    }
  }

  setTabList() {
    this.tabList = [
      {
        label : 'New Fields'
      },
      {
        label: 'Existing Fields'
      }
    ]
  }

  setExistingItemsNodes() {
    const formNodeGroup: FormNodeGroup = {
      id: 'existingItemsfields',
      title: 'Existing Items Fields',
      description: 'You can choose this fields to build your form as per your requirement.',
      order: 1,
      nodes: []
    };
    const nodes: any[] = [];
    this.existingQuestions.forEach( (question) => {
      const formNode = {
        id : question.id,
        title : question.title,
        description : question.instruction,
        fieldKey : question.fieldKey,
        isExistingItem: true,
        fieldValues: question.fieldValues,
      };
      if (!nodes.find(e => e.id === formNode.id)) {
        nodes.push(formNode);
      }
    });
    formNodeGroup.nodes = nodes;


    this.nodeGroups = [
      formNodeGroup
    ];
    this.viewNodeGroups = this.nodeGroups;
  }

  onTabChanged($event: any) {
    console.log($event);
    if ($event.index === 0) {
      this.setNodes(this.customDataTypes);
    } else if ($event.index === 1) {
      this.setExistingItemsNodes();
    }
  }

  setNodes(customDataTypes: any) {
    const formNodeGroup: FormNodeGroup = {
      id: 'fields',
      title: 'Fields',
      description: 'You can choose this fields to build your form as per your requirement.',
      order: 1,
      nodes: []
    };
    const nodes: FormNode[] = [];
    customDataTypes.forEach( (dataType) => {
      const formNode: FormNode = {
        id : dataType.header + '-' + dataType.dataType,
        title : dataType.header,
        description : dataType.header,
        utility : dataType.header,
        order: dataType.order,
        frozen: dataType.frozen,
        instruction: dataType.instruction,
        cellEditor: dataType.cellEditor,
        cellViewer: dataType.cellViewer,
        children: dataType.children,
        configKey: dataType.configKey,
        dataType: dataType.dataType,
        fieldValues: dataType.fieldValues,
        formulaField: dataType.formulaField,
        isCustom: dataType.isCustom,
        isMandatory: dataType.isMandatory,
        isReadOnly: dataType.isReadOnly,
        metaData: dataType.metaData,
        options: dataType.options,
        questionId: dataType.questionId,
      };
      if (!nodes.find(e => e.id === formNode.id)) {
        nodes.push(formNode);
      }
    });
    formNodeGroup.nodes = nodes;


    this.nodeGroups = [
      {
        id: 'general',
        title: 'General',
        description: 'Select the core form elements including pages, titles and descriptions.',
        order: 1,
        nodes: EliteFormGeneralNodes as FormNode[]
      },
      formNodeGroup
    ];


    const targetNodeGroup = this.nodeGroups.find(group => group.id === 'general');
    const targetFormGroup=formNodeGroup.nodes.find(group => group.id === 'Group-Group');
    if (targetNodeGroup && targetFormGroup) {
      const alreadyExists = targetNodeGroup.nodes.some(node => node.id === targetFormGroup.id);
      if (!alreadyExists) {
        targetNodeGroup.nodes.push(targetFormGroup);
      }
    }
    formNodeGroup.nodes = nodes.filter(group => group.id !=='Group-Group' );
    this.viewNodeGroups = this.nodeGroups;
  }
  onClickedNodeItem(node: any) {

  }

  showNodeDescriptionDialog(node: any) {
    // if (node.utility) {
    //   this.dialogService.showDialogMessage(node.title, node.utility).subscribe(res => {});
    // }
  }

  private onValueChanges(value) {
    const text = value.toLowerCase();
    this.viewNodeGroups = _.cloneDeep(this.nodeGroups);
    if (!this.currentText || this.currentText.length === 0) {
      this.isOpen = [];
      this.isOpen[0] = true;
    }
    if (this.currentText === text) {
      this.viewNodeGroups.forEach((tempNodeGroup, index) => {
        this.isOpen[index] = false;
        tempNodeGroup.nodes = this.searchText(tempNodeGroup.nodes, text);
        if (tempNodeGroup.nodes && tempNodeGroup.nodes.length !== 0) {
          this.isOpen[index] = true;
        }
      });
    }
    return;
  }

  private searchText(nodes: any[], text: string) {
    const result = [];
    nodes.forEach(node => {
      if (node.title.toLowerCase().includes(text)) {
        result.push(node);
      }
    });
    return result;
  }

  async getFlatQuestions() {
    return await this.flowChartDataService.getUniqueFlatQuestionsByFlowchartId();
  }

  onDragStart(event: any) {

  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}

export class FormNode {
  id: string;
  title: string;
  description: string;
  utility: string;
  order: number;
  frozen: boolean;
  instruction: string;
  questionId: string;
  isMandatory: boolean;
  formulaField: string;
  options: OptionItem[];
  isReadOnly: boolean;
  isCustom: boolean;
  cellViewer: string;
  cellEditor: string;
  fieldValues: any = {};
  metaData: any = {};
  configKey: string;
  dataType: string;
  children: FormNode[];
}

export class FormNodeGroup {
  id: string;
  title: string;
  description: string;
  order: number;
  nodes: FormNode[];
}
